
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/awscodepipeline",
      function () {
        return require("private-next-pages/services/awscodepipeline/index.tsx");
      }
    ]);
  